import React from 'react';
import PropTypes from 'prop-types';

const SIZES = {
  avatar: 'tw-h-8 tw-w-8 tw-rounded-full tw-text-[11px] tw-font-bold',
  avatarLg: 'tw-h-11 tw-w-11 tw-rounded-full tw-text-sm tw-font-bold',
  avatarXl: 'tw-h-16 tw-w-16 tw-rounded-full tw-text-xl tw-font-bold',
  xs: 'tw-h-9 tw-w-9 tw-rounded-xl',
  sm: 'tw-h-8 tw-w-8 tw-rounded-[10px] tw-text-[11px] tw-font-bold',
  md: 'tw-h-12 tw-w-12 tw-rounded-2xl',
  lg: 'tw-h-14 tw-w-14 tw-rounded-[18px]',
  xl: 'tw-h-20 tw-w-20 tw-rounded-[26px]',
};

/**
 * Tinted "liquid glass" tile: the accent gradient seen through a glass layer
 * with a specular highlight on the top-left, a bright rim and an inner shade.
 * `gradient` carries the from-/to- colours and the glow's shadow colour.
 */
const GlassIcon = ({ gradient, size = 'md', className = '', children }) => (
  <span
    className={`tw-relative tw-grid tw-shrink-0 tw-place-items-center tw-bg-gradient-to-br tw-text-white tw-shadow-lg ${gradient} ${SIZES[size]} ${className}`}
  >
    <span
      aria-hidden="true"
      className="tw-pointer-events-none tw-absolute tw-inset-0 tw-rounded-[inherit] tw-border tw-border-white/45 tw-bg-[radial-gradient(130%_80%_at_25%_0%,rgba(255,255,255,0.6),rgba(255,255,255,0)_58%),linear-gradient(180deg,rgba(255,255,255,0.12),rgba(255,255,255,0)_60%)] tw-shadow-[inset_0_1px_1px_rgba(255,255,255,0.85),inset_0_-2px_4px_rgba(15,23,42,0.18)]"
    />
    <span className="tw-relative tw-grid tw-place-items-center tw-drop-shadow-[0_1px_1.5px_rgba(15,23,42,0.35)]">
      {children}
    </span>
  </span>
);

GlassIcon.propTypes = {
  gradient: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.keys(SIZES)),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default GlassIcon;
